const appKeys = {
  keys: {
    mapBoxKey: 'pk.eyJ1IjoibWl0LXByb2R1Y3QtbWFwcyIsImEiOiJja2htMXpsYWowNjBkMnlxMWdtYTdjcmFjIn0.2JgsLng6v3GIHt34-aeEjw'
  }
}
export default appKeys
